<template>
  <div :id="itemId" class="card-news-agency">
    <div class="d-flex head-img-title align-items-center">
      <div class="flex-grow-1">
        <span class="kicker" v-html="item.header"></span>
        <h2 v-html="item.title"></h2>
        <button
          @click="readContent()"
          class="read-more"
          v-bind:class="{ up: openContent }"
        >
          {{ contentTagcontrol }} <i class="icon-keyboard_arrow_down"></i>
        </button>
      </div>
      <div class="col-4">
        <img v-if="item.imageUrl" :src="item.imageUrl" />
      </div>
    </div>
    <div
      class="content-news-agency"
      v-bind:class="{ show: openContent }"
      v-html="item.content"
    ></div>
    <div class="footer">
      <div class="company" v-if="item.companyName">
        <strong>EMPRESA: </strong>
        <span v-html="item.companyName"></span>
      </div>
      <div class="agency" v-if="item.agencyLogoUrl">
        <strong>Agencia: </strong>
        <a :href="item.agencyUrl">
          <img :src="item.agencyLogoUrl" />
        </a>
      </div>
    </div>
    <a
      v-if="item.relatedUrl"
      :href="item.relatedUrl"
      target="_blank"
      class="btn"
    >
      NOTA RELACIONADA
    </a>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  methods: {
    readContent: function () {
      this.openContent = !this.openContent;
    },
  },
  computed: {
    itemId: function () {
      return `caitem-${this.item.id}`;
    },
    contentTagcontrol: function () {
      return this.openContent ? "OCULTAR" : "LEER";
    },
  },
  data: function () {
    return {
      openContent: false,
    };
  },
};
</script>